import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../../styles.module.scss'
import CardTitle from '../../common/CardTitle'
import { useTranslation } from 'react-i18next'
import EmptyCard from '../../common/EmptyCard'
import ActivityBoxInvitations from '../../common/ActivityBoxInvitations'
import { isEmpty } from 'lodash'
import CardSubTitle from '../../common/CardSubTitle'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import Button from 'srcReact/components/common2/Button'
import InviteAcceptanceRateGraph from './InviteAcceptanceRateGraph'
import { useDispatch, useSelector } from 'react-redux'
import { dashboardActions } from 'srcReact/Dashboard/actions'
import { toast } from 'react-hot-toast'
import { Alert } from 'srcReact/components/common2/Alert'
import { commonActions } from 'srcReact/components'
import UserList from '../../common/UserList'
import { isMobileScreen, uuid } from 'srcReact/helpers/utils'

function PendingInvitations({ type, objectId, invitationData }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [invitations, setInvitations] = useState([])
  const [renewTriggered, setRenewTriggered] = useState(false)
  const [cancelTriggered, setCancelTriggered] = useState(false)

  const {
    dashboardDetail: { renewInvitation, cancelInvitation }
  } = useSelector((state) => state)

  useEffect(() => {
    setInvitations(invitationData.Pending_invite)
  }, [invitationData])

  useEffect(() => {
    if (!renewInvitation.loading && renewTriggered) {
      setRenewTriggered(false)
      if (renewInvitation.success) {
        dispatch(
          commonActions.updateBannerData({
            id: uuid(),
            wizard: 'Elena',
            color: '#FEB200',
            duration: 2,
            content:
              renewInvitation.userId === -1 //-1 is for renew all invitations
                ? t('dashboard.invitations.renewSuccess_plural')
                : t('dashboard.invitations.renewSuccess')
          })
        )
      }
      if (renewInvitation.error) {
        toast.custom((toastProps) => <Alert text={renewInvitation.error} type='error' toastProps={toastProps} />, {
          duration: 1500
        })
      }
    }
  }, [renewInvitation, renewTriggered])

  useEffect(() => {
    if (!cancelInvitation.loading && cancelTriggered) {
      setCancelTriggered(false)
      if (cancelInvitation.success) {
        dispatch(
          commonActions.updateBannerData({
            id: uuid(),
            wizard: 'Elena',
            color: '#FEB200',
            duration: 2,
            content: t('dashboard.invitations.cancelSuccess')
          })
        )
      }
      if (cancelInvitation.error) {
        toast.custom((toastProps) => <Alert text={error} type='error' toastProps={toastProps} />, {
          duration: 1500
        })
      }
    }
  }, [cancelInvitation, cancelTriggered])

  const sendAgain = (user) => {
    setRenewTriggered(true)
    dispatch(dashboardActions.renewInvitation(type, objectId, user.id, user.email))
  }
  const cancelInvite = (user) => {
    setCancelTriggered(true)
    dispatch(dashboardActions.cancelInvitation(type, objectId, user.id))
  }
  const resendAllInvites = () => {
    setRenewTriggered(true)
    if (type === 'group') {
      dispatch(dashboardActions.renewAllInvitations(objectId))
    } else if (type === 'workplace') {
      const emails = invitations.map((inv) => inv.value).join(',')
      dispatch(dashboardActions.renewInvitation(type, objectId, null, emails))
    }
  }

  const getDropdownOptions = (user) => {
    const items = []
    items.push({
      text: t('global.sendAgain'),
      onClick: () => sendAgain(user)
    })
    items.push({
      text: t('components.invite_list.cancel'),
      onClick: () => cancelInvite(user)
    })

    return items
  }

  return (
    <div className={`${parentStyles.card} `}>
      {type === 'group' && <CardTitle title={t('dashboard.invitations.title')} />}

      <div className={styles.pendingInvitation}>
        <div className={styles.invitationData}>
          <CardSubTitle title={t('dashboard.pendingInvitesCount', { count: invitations.length || 0 })} />
          {invitations.length > 0 ? (
            <UserList
              users={invitations}
              showTime={true}
              renderAction={(userInfo) => (
                <React.Fragment>
                  <Button
                    customStyle={styles.renewButton}
                    handleClick={() => sendAgain(userInfo)}
                    style='transparent'
                    size={isMobileScreen() ? 'small' : 'medium'}
                    text={t('dashboard.renew')}
                  />
                  <ReactMenu
                    ariaLabel={t('formlabel.openMoreOptions')}
                    options={getDropdownOptions(userInfo)}
                    menuCSS={styles.optionsMenu}
                  />
                </React.Fragment>
              )}
              onlyEmail={type === 'workplace'}
            />
          ) : (
            <EmptyCard
              className={styles.invites}
              contentTitle={t('dashboard.invitations.empty.title')}
              contentText={t('dashboard.invitations.empty.text')}
              contentImage='pending-invites'
              contentButton={t('global.inviteMembers')}
              linkTarget='_blank'
              contentButtonLink={
                type === 'group'
                  ? `/0/group/${objectId}/invite-members`
                  : `/0/workplace/settings/${objectId}?section=link_2`
              }
            />
          )}
        </div>

        {!isMobileScreen() && (
          <div className={styles.activityDataContainer}>
            <ActivityBoxInvitations
              activityText={
                parseInt(invitationData?.Invite_no_reply_count?.value) > 1
                  ? t('dashboard.invitations.empty.activityTitlePl')
                  : t('dashboard.invitations.empty.activityTitle')
              }
              activityCount={
                isEmpty(invitationData?.Invite_no_reply_count)
                  ? 0
                  : parseInt(invitationData?.Invite_no_reply_count?.value)
              }
              handleResendAll={resendAllInvites}
            />

            <InviteAcceptanceRateGraph
              acceptaceRate={invitationData?.Invite_acceptance_rate.value}
              acceptanceRateVariant={invitationData?.Invite_acceptance_rate_variation.value}
              graphData={invitationData?.Invite_acceptance_rate_graph}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default PendingInvitations
